import { ensureNoUndefinedProperties } from '@/Shared/Helper/EnsureNoUndefinedProperties'
import CompanyID from '@/App/Company/Entity/CompanyID'
import CompanyCustomerID from '@/App/Company/Entity/CompanyCustomerID'
import CustomerID from '@/App/Customer/Entity/CustomerID'
import type { CompanyCustomerData } from '@/Shared/AutoGenerated/Main'

export default class CompanyCustomer {
    constructor(
        public readonly id: CompanyCustomerID,
        public readonly companyId: CompanyID,
        public readonly customerId: CustomerID,
        public readonly createdAt: string,
    ) {
        ensureNoUndefinedProperties(this)
    }

    // ------------------------
    // Hydration
    // ------------------------

    static hydrateSingle(entityData: CompanyCustomerData): CompanyCustomer {
        return new CompanyCustomer(
            new CompanyCustomerID(entityData.id),
            new CompanyID(entityData.companyId),
            new CustomerID(entityData.customerId),
            entityData.createdAt,
        )
    }

    static hydrateMultiple(
        entitiesData: CompanyCustomerData[],
    ): CompanyCustomer[] {
        return entitiesData.map((entityData) => this.hydrateSingle(entityData))
    }
}
